export function createSmokeEffect(grenade, currentTick, getConvertedCords, getObjectOpacity, pixelsPerMapUnit) {
  if (!grenade) return null;

  const effectStartTick = grenade.effectStartTick || 0;
  const destroyTick = grenade.destroyTick || Infinity;

  if (currentTick < effectStartTick || currentTick >= destroyTick) {
    return null;
  }

  let smokeX = grenade.grenadeX;
  let smokeY = grenade.grenadeY;
  let smokeZ = grenade.grenadeZ || 0;

  if (grenade.vectors && grenade.vectors.length > 0) {
    const lastVector = grenade.vectors[grenade.vectors.length - 1];
    if (lastVector.x !== undefined && lastVector.y !== undefined) {
      smokeX = lastVector.x;
      smokeY = lastVector.y;
      smokeZ = lastVector.z !== undefined ? lastVector.z : smokeZ;
    }
  }

  const cords = getConvertedCords(smokeX, smokeY);
  if (!cords) return null;

  const remaining = Math.max(0, (destroyTick - currentTick) / 64);
  const timer = Math.ceil(remaining);

  const baseRadiusU = 25;
  const radius = baseRadiusU * (pixelsPerMapUnit || 1);

  const opacity = 0.4;

  return {
    uniqueID: grenade.uniqueID,
    x: cords.x,
    y: cords.y,
    z: smokeZ,
    radius,
    color: getProjectileColor(grenade.grenadeType),
    timer,
    opacity: getObjectOpacity ? getObjectOpacity(smokeZ, opacity) : opacity,
  };
}

function getProjectileColor(grenadeType) {
  const typeLower = grenadeType?.toLowerCase() || '';
  if (typeLower.includes('smokegrenade') || typeLower === 'smoke') {
    return '#808080';
  }
  return '#808080';
}

export function updateSmokes(roundData, currentTick, getConvertedCords, getObjectOpacity, pixelsPerMapUnit) {
  if (!roundData || !roundData.grenades) return [];

  const activeSmokes = [];

  roundData.grenades.forEach((grenade) => {
    const grenadeType = grenade.grenadeType?.toLowerCase() || '';
    if (!grenadeType.includes('smokegrenade') && grenadeType !== 'smoke') {
      return;
    }

    const smoke = createSmokeEffect(grenade, currentTick, getConvertedCords, getObjectOpacity, pixelsPerMapUnit);
    if (smoke) {
      activeSmokes.push(smoke);
    }
  });

  return activeSmokes;
}
